<div class="dialog-container selection">
  <div cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" class="dialog-header">
    <h4>{{ "users.selectUser" | translate }}</h4>
    <button class="icon-close" (click)="dialogRef.close()"></button>
  </div>
  <div class="container container--search">
    <div class="search-bar">
      <div class="first-row">
        <div class="input-container flex-1">
          <sag-ui-input class="primary-input flex-1" [(ngModel)]="query.firstName" [type]="'text'" [label]="'First name'" (keyup)="keyUp.next($event)" />
          <sag-ui-input class="primary-input flex-1" [(ngModel)]="query.lastName" [type]="'text'" [label]="'Last name'" (keyup)="keyUp.next($event)" />
          <sag-ui-input class="primary-input flex-1" [(ngModel)]="query.eMail" [type]="'text'" [label]="'E-mail'" (keyup)="keyUp.next($event)" />
          <sag-ui-input class="primary-input flex-1" [(ngModel)]="query.gid" [type]="'text'" [label]="'GID'" (keyup)="keyUp.next($event)" />
        </div>
      </div>
    </div>
  </div>
  <div class="container container--table">
    <div class="section-container table-section">
      <div #itemContainer class="table-container">
        <div class="item-container">
          @if (pagedData?.items && pagedData?.totalItems !== 0) {
            @for (user of paginatedData; track user) {
              <app-user-item (click)="changeSelected(user)" [active]="user.selected" [item]="user" />
            }
          }

          @if (!data?.disableExternal && isQuerying && !isLoadedExternal) {
            <div (click)="loadExternal(true)" class="user-item-container more-user-button">
              {{ "users.userSelectionScd" | translate }}
            </div>
          }
        </div>
        @if (!pagedData || (pagedData?.totalItems === 0 && isLoadingExternal)) {
          <app-loading-indicator />
        }
      </div>
    </div>
  </div>
  <div class="container container--sticky-bottom">
    <div class="section-container button-container">
      <sag-ui-button color="secondary" (click)="dialogRef.close()">{{ "default.buttons.cancel" | translate }}</sag-ui-button>
      <sag-ui-button (click)="closeDialog()">{{ "default.buttons.confirm" | translate }}</sag-ui-button>
    </div>
  </div>
</div>
